import { axiosCashJournalClient } from "./api";
import { MIDDLE_URL } from "./config";

export interface IAreaData {
  id: string,
  name: string,
}
export interface IGetAreasResponse {
  listareaall: IAreaData[]
}

const url = "/v1/area";

export const getAreas = async (): Promise<IGetAreasResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}`,
    method: "GET",
  });

  return data;
};
